export default __webpack_public_path__ + "static/hero-space-suitcase-948a9e2aa803e99c8b399fb460d6b7d7.jpg";